<template>
    <modal
    name="permit-custom-message"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="650"
    height="auto"
    @before-open="getData"
    @closed="closeModal()"
    >
    <div class="modalWrapper">
         <div class="content__box">
              <div class="content__box__header">
                <p class="text-white txt--ss opacity--50">Add Custom Message</p>
               </div>
                <div class="content__divider"></div>
                    <div class="content__box__body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form__group mb-3">
                                     <Text-area
                                      label="Custom Message"
                                      v-model="permit_custom_message"
                                      :value="permit_custom_message"
                                      :rows="5"
                                      :charRequired="false"
                                    />
                                </div>
                               <div class="form-group">
                                <app-toggle
                                  :checked="customMessage"
                                  :label="'Active custom message'"
                                  @update:checked="checkMessagestatus($event, 'customMessage')"
                                ></app-toggle>
                              </div>
                            </div>
                        </div>
                    </div>
         </div>
        <div class="d-flex justify-content-center flex-wrap mt-4">
        <button
          type="button"
          class="button button--primary button--sm mr-3"
          :disabled="disabled"
          @click="addCustomemessage()"
        >
          Save</button
        ><button
          type="button"
          class="button button--outline button--sm"
          @click="closeModal()"
        >
          Cancel
        </button>
        </div>
        <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
         </div>
    </div>
    </modal>
</template>
<script>
import Textarea from "@/components/Textarea";
import Toggle from "@/components/toggle";
export default {
  name:'PermitCustomMessage',
  components:{
      AppToggle: Toggle,
     "Text-area": Textarea,
  },
  data(){
    return{
      permit_id:'',
      permit_custom_message:'',
      disabled:false,
      customMessage:false,
    }
  },
  created(){
    // this.getData();
  },
  methods:{
    getData(e){
      // console.log(e.params.permit);
      this.permit_custom_message=e.params.permit.permit_custom_message;
      this.permit_id=e.params.permit.permit_id;
      this.customMessage = e.params.permit.custom_message_status === 1 ? true : false;
    },
    resetData(){
     this.permit_custom_message = "";
    },
    closeModal() {
      this.$modal.hide("permit-custom-message");
    },
    addCustomemessage(){
      // console.log(this.permit_custom_message);
      this.axios.post(window.hostname+ 'api/auth/permit/add-custom-message',{
        permit_id:this.permit_id,
        permit_custom_message:this.permit_custom_message,
        custom_message_status: this.customMessage ? 1 : 0,
      }).then(res=>{
        // console.log(res);
          if(res.data.status) {
             this.$toasted.show(res.data.message,{
              icon:'check-circle',
              className: 'success-class'
            });
            this.$emit("update_list",true);
            this.resetData();
            this.closeModal();
          }
          else {
            this.$toasted.show(res.data.message,{
              icon: 'times-circle',
              className: 'error-class'
            });
          }
      })
      .catch(err=>{
        console.log(err);
      })
    },
    checkMessagestatus(checked,type){
      if (type == "customMessage") {
        this.customMessage = checked;
      
      }
    }
  },
}
</script>
